import api from "@/utils/request";


export interface ApiResponse {
  result?: any; // 返回结构
  status: any;
}
export const getAllMenu = async () => {
  let result:ApiResponse = {
    result:{},
    status:{}
  }
  await api.request({
        method: 'get',
        url: '/hive/sys/resource/tree/all',
        headers: {
            "Content-Type": "application/json"
        },
    }).then(res => {
        result = res
    })
  return result
}
export const getRoleMenu = async (roleId: number) => {
  let result:ApiResponse = {
    result:{},
    status:{}
  }
  await api.request({
        method: 'post',
        url: '/hive/sys/resource/tree/role',
        headers: {
            "Content-Type": "application/json"
        },
        data: JSON.stringify({roleId:roleId}),
    }).then(res => {
        result = res
    })
  return result
}